import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Save, RotateCcw } from "lucide-react";

export function SectionHeader({ title, description, onSave, onReset, saving, saveLabel = "Save changes" }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        <h1 className="font-display font-black tracking-tighter text-2xl md:text-3xl">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-[#5C534D] max-w-2xl text-sm md:text-base">
            {description}
          </p>
        )}
      </div>
      <div className="flex items-center gap-3">
        {onReset && (
          <Button
            type="button"
            variant="outline"
            onClick={onReset}
            disabled={saving}
            data-testid="admin-reset-btn"
            className="h-10 rounded-full text-sm"
          >
            <RotateCcw className="h-4 w-4 mr-2" />
            Reset to defaults
          </Button>
        )}
        {onSave && (
          <Button
            type="button"
            onClick={onSave}
            disabled={saving}
            data-testid="admin-save-btn"
            className="h-10 rounded-full bg-[#E53935] hover:bg-[#C62828] text-white text-sm px-5"
          >
            {saving ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <>
                <Save className="h-4 w-4 mr-2" />
                {saveLabel}
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
}

export function Panel({ children, className = "" }) {
  return (
    <div
      className={`rounded-3xl bg-white border border-[#E8DED5] p-6 md:p-8 ${className}`}
    >
      {children}
    </div>
  );
}

export function FieldRow({ children, cols = 2 }) {
  const gridCls = cols === 3 ? "md:grid-cols-3" : "md:grid-cols-2";
  return <div className={`grid grid-cols-1 ${gridCls} gap-5`}>{children}</div>;
}
